import React from "react";
import { vehicleInfoIcon } from "utils/fuelEcoIcon/fuelAssets";
import ReactMarkdown from "react-markdown";
import replaceLinkHost from "../../../../utils/replaceLinkHost";
import { isMobile } from "react-device-detect";

export type ChargeTypeVehicleInfoProps = {
  title?: string;
  markdownText: string;
};

const ChargeTypeVehicleInfo = ({ title, markdownText }: ChargeTypeVehicleInfoProps) => {
  const mobileSection = (
    <>
      <div className="col col-auto d-flex align-items-center justify-content-between py-13 pr-sm-3">
        <img className="vehicle-info-fuel-box-icon" src={vehicleInfoIcon} alt="" />
        {title && <h5 className="mb-2 text-center">{title}</h5>}
      </div>
      <div className="col d-flex flex-column align-items-top">
        <ReactMarkdown linkTarget="_blank" className="markdown">
          {replaceLinkHost(markdownText)}
        </ReactMarkdown>
      </div>
    </>
  );
  const desktopSection = (
    <>
      <div className="col col-auto py-13 pr-0 pr-sm-3">
        <img className="vehicle-info-fuel-box-icon" src={vehicleInfoIcon} alt="" />
      </div>
      <div className="col d-flex flex-column align-items-top">
        {title && <h5 className="mb-2">{title}</h5>}
        <ReactMarkdown linkTarget="_blank" className="markdown">
          {replaceLinkHost(markdownText)}
        </ReactMarkdown>
      </div>
    </>
  );

  return (
    <div className="vehicle-info-fuel-box d-flex align-items-top mt-6 px-sm-4 py-3 font-weight-normal flex-column flex-sm-row">
      {isMobile ? mobileSection : desktopSection}
    </div>
  );
};

export default ChargeTypeVehicleInfo;
